module.exports = __webpack_public_path__ + "media/images/smart_phone/toplogo_08-cd0a05370e95c4a084bd9229ed138fa9.png";